import { request, requestUtil } from "../../apis";

export const apiGetProductItems = (params: any): any =>
  request("get", `/api/product/item/check`, params, false);

export const apiCheckDiscount = (params: any): any =>
  request("get", `/api/discount/check`, params, true);

export const apiCheckPromote = (params: any): any =>
  request("get", `/api/promote/check`, params, true);

export const apiPostCheckoutCart = (params: any): any =>
  request("post", `/api/order/place`, params, true);

export const apiGetGiftPointRatio = (params: any): any =>
  requestUtil("get", `/api/setting/gift/point`, params, true);
